module.exports = __webpack_public_path__ + "static/media/kajal-k.fee03484.jpeg";